
import { defineComponent, inject } from 'vue';

export default defineComponent({
  setup() {
    // eslint-disable-next-line @typescript-eslint/ban-types
    const localize = inject('$localize') as Function;
    return { localize };
  },
});
